// eslint-disable-next-line no-shadow
export enum LogLevel {
  None,
  Debug,
  Warn,
  Error,
}
